import { render, staticRenderFns } from "./RegisterWave.vue?vue&type=template&id=b29ba7a4&scoped=true&"
import script from "./RegisterWave.vue?vue&type=script&lang=ts&"
export * from "./RegisterWave.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterWave.vue?vue&type=style&index=0&id=b29ba7a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29ba7a4",
  null
  
)

export default component.exports